var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlovakia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 5.217H0v5.566h24V5.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 10.783H0v5.22h24v-5.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M6.068 4.52v3.99c0 2.25 3 3 3 3s2.962-.697 2.962-3V4.52H6.068z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.847 4.64v3.84c-.002.26.057.517.173.75h4.027a1.65 1.65 0 00.173-.75V4.64H6.847z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M10.373 7.317H9.368V6.65h.667v-.675h-.667v-.667H8.7v.667h-.667v.675H8.7v.667H7.695v.668H8.7v.675h.668v-.675h1.005v-.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M7.935 10.137c.345.213.716.381 1.103.503.384-.12.752-.29 1.095-.503a2.4 2.4 0 00.915-.93 1.148 1.148 0 00-.675-.217 1.504 1.504 0 00-.263 0 1.17 1.17 0 00-2.145 0 1.623 1.623 0 00-.27 0c-.242 0-.478.075-.675.218.213.388.53.71.915.93z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakia);
export default __webpack_public_path__ + "static/media/Slovakia.ff32949a9296a995d4ef01a3eb077f91.svg";
export { ForwardRef as ReactComponent };